import { ArticleModel } from "../archive/article.model";
import { MasterSolutionModel } from "./master-solution.model";

export class MasterSolutionDetailModel {
  masterSolutionDetailId: number = 0;
  masterSolutionId: number = 0;
  masterSolution: MasterSolutionModel | null = null;
  articleId: number = 0;
  article: ArticleModel | null = null;
  quantity: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
  selection: boolean = false;
}






